"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCamelCase = toCamelCase;
exports.toPascalCase = toPascalCase;
exports.transformJsonObject = transformJsonObject;
exports.transformObjectToCamelCase = transformObjectToCamelCase;
exports.transformObjectToPascalCase = transformObjectToPascalCase;
var _lodash = require("@avantia/lodash");
var _loggingAndErrors = require("@avantia/logging-and-errors");
function transformJsonObject(node, keyTransform) {
  if (typeof node !== 'object' || node === null || node === undefined) {
    return node;
  }
  return transformJsonObjectInner(node, keyTransform, 0);
}
function transformJsonObjectInner(node, keyTransform, depth) {
  if (depth > 100) {
    throw new _loggingAndErrors.HpError(`The input contains circular references (depth: ${depth})`);
  }
  if (node === null || node === undefined) {
    return node;
  }
  if (typeof node === 'object') {
    if (_lodash.lodash.isArray(node)) {
      return node.map(item => transformJsonObjectInner(item, keyTransform, depth + 1));
    }
    const keys = Object.getOwnPropertyNames(node);
    const res = {};
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      let value = node[key];
      const isUndefined = value === undefined;
      if (value !== null && !isUndefined && typeof value === 'object') {
        value = transformJsonObjectInner(value, keyTransform, depth + 1);
      }
      const newKey = keyTransform(key, depth, res);
      if (newKey && !isUndefined) {
        res[newKey] = value;
      }
    }
    return res;
  }
  return node;
}
function transformObjectToCamelCase(node) {
  return transformJsonObject(node, toCamelCase);
}
function transformObjectToPascalCase(node) {
  return transformJsonObject(node, toPascalCase);
}
function toPascalCase(name) {
  if (name === undefined || name === null) {
    return '';
  }
  name = `${name}`;
  return name.slice(0, 1).toUpperCase() + name.slice(1);
}
function toCamelCase(name) {
  if (name === undefined || name === null) {
    return '';
  }
  name = `${name}`;
  return name.slice(0, 1).toLowerCase() + name.slice(1);
}